import { render } from "./predict-nav-icon.vue.js?vue&type=template&id=33f75c4a!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./predict-nav-icon.vue?vue&type=template&id=33f75c4a"
const script = {}

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__